import { FortuneDoubleCardProps } from './props';
import { CardSkeleton, Container, Icon, Image } from './styles';

export default function FortuneDoubleCard({
  data,
  isLoading,
}: FortuneDoubleCardProps) {
  if (isLoading) {
    return (
      <Container>
        <CardSkeleton />
      </Container>
    );
  }

  return (
    <Container>
      <Image
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/fortune-double/backgrounds/${data?.type?.image?.split?.('/')?.[1]}/card.png`}
        alt={`Frost card ${data.type}`}
      />

      <Icon
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/fortune-double/icons/${data?.image}`}
        alt={`Frost icon ${data.type}`}
      />
    </Container>
  );
}
